//SERVES AS A CATCH ALL FOR OTHER BITS OF CONTEXT THAT DON'T REALLY NEED THEIR OWN OR FIT ANYWHERE ELSE

import { createContext, useContext, useState } from 'react'
import circuit1 from './imgs/circuit5.png'
import circuit2 from './imgs/circuit6.jpg'
import journey14 from './imgs/journey14.jpg'
import useImg from '#Hooks/ReusableImg'

const GeneralContext = createContext();

export default function useGeneralContext() {
    return useContext(GeneralContext)
}

export function GeneralContextProvider({ children }) {
    // console.log('General Provider Render')
    // Images that get drawn into different canvases, prevents reloading same img over and over
    const circuitImg = useImg(circuit1);
    const circuitImg2 = useImg(circuit2);
    const aboutAccordionImg = useImg(journey14); 

    //don't want to reperform fade on subsequent revisits
    const [aboutFadeCompleted, setAboutFadeCompleted] = useState(false)

    return (
        <GeneralContext.Provider value={{
            circuitImg,
            circuitImg2,
            aboutAccordionImg,
            aboutFadeCompleted, setAboutFadeCompleted
        }}>
            {children}
        </GeneralContext.Provider>
    )
}